import React from "react";
import HomeBanner from "../../assets/images/gowrianadham.png";
import Banner from "../../components/header/banner";
import GowriAnandhamLocation from "./locationGowriAnandham";
import GowriAnandhamFeature from "./gowrianandhamFeature";

import GowriAnandhamMap from "./gowrianandhamMap";
import HomeEnquiryPopup from "../home/homeEnquiryPopup";

import location from "../../assets/icons/features/location.png";
import hand from "../../assets/icons/features/hand.png";
import legal from "../../assets/icons/features/legal.png";
import money from "../../assets/icons/features/money.png";
import school from "../../assets/icons/features/school.png";
import water from "../../assets/icons/features/water.png";
import AboutGowriAnandham from "../../assets/images/card22.png";
import GowriAnandhamBrochure from "../../assets/brochures/gowri-anandham-kanchipuram-brochure.pdf";
import "./gowrianandham.css";
import { PlotsAdvantages } from "../../components/plots/plots";
import SliderVideo from "../../components/sliders/vsliders";
import { DownloadBrochure } from "../../components/download_brochure/download_brochure";

/**
 * @function GowriAnandham
 * Clone of the Kanchipuram page ("/kanchipuram"), served at "/gowri-anandham".
 * Adds the same auto-open, no-close-button enquiry popup + sticky button
 * used on "/utsav", tagged with its own source/referrer for lead tracking.
 * "Download Brochure" here also delivers the actual PDF after a lead
 * submits — every other page's brochure button is unaffected.
 **/

export const GowriAnandham = (props) => {
  const featureDetails = [
    {
      id: 1,
      imgSrc: location,
      imgText: "location",
      title: "Just next to Konnerikuppum.",
    },
    {
      id: 2,
      imgSrc: hand,
      imgText: "hand",
      title: "High appreication potential.",
    },
    {
      id: 3,
      imgSrc: legal,
      imgText: "legal",
      title: "Legal and title documents are clear hassle free transactions.",
    },
    {
      id: 4,
      imgSrc: money,
      imgText: "money",
      title: "Best in segment pricing for ready to construct plots.",
    },
    { id: 5, imgSrc: water, imgText: "water", title: "Potable groundwater." },
    {
      id: 6,
      imgSrc: school,
      imgText: "school",
      title: "Surrounded by schools, colleges and all essentials.",
    },
    {
      id: 11,
      imgSrc: location,
      imgText: "location",
      title: "Just next to Konnerikuppum.",
    },
    {
      id: 12,
      imgSrc: hand,
      imgText: "hand",
      title: "High appreication potential.",
    },
    {
      id: 13,
      imgSrc: legal,
      imgText: "legal",
      title: "Legal and title documents are clear hassle free transactions.",
    },
    {
      id: 14,
      imgSrc: money,
      imgText: "money",
      title: "Best in segment pricing for ready to construct plots.",
    },
    { id: 15, imgSrc: water, imgText: "water", title: "Potable groundwater." },
    {
      id: 16,
      imgSrc: school,
      imgText: "school",
      title: "Surrounded by schools, colleges and all essentials.",
    },
  ];

  return (
    <div>
      <HomeEnquiryPopup
        source="Gowri Anandham Popup Form"
        referrer="https://anandhamplots.com/gowri-anandham"
        campaignName="Pon_Ananatham_Search_Campaign_01"
      />
      <Banner bannerImgSrc={HomeBanner} />
      <WhyGowriAnandham />
      <h2 className="ga-features-heading green-text heading-bold">
        Features at Anandhamplots
      </h2>
      <GowriAnandhamFeature details={featureDetails} />
      <h2 className="ga-features-heading green-text heading-bold">
        Promising Locations
      </h2>
      <GowriAnandhamLocation />
      <PlotsAdvantages />
      <GowriAnandhamMap />
      <SliderVideo />
    </div>
  );
};

const WhyGowriAnandham = () => {
  return (
    <div className="ga-why">
      <img src={AboutGowriAnandham} alt="About Gowri Anandham" />
      <div className="ga-why-content">
        <h4>Why Anandham Kanchipuram?</h4>
        <p>
          Kanchipuram is renowned for its rich cultural heritage and burgeoning
          infrastructure. Here, buying residential plots for sale in Kanchipuram
          presents a lucrative investment opportunity for several compelling
          reasons.
        </p>
        <p>
          This historic city, located just a short drive from Chennai, combines
          the allure of traditional charm with the benefits of modern living.
          Investing in Kanchipuram means more than just acquiring property; it's
          about becoming part of an excellent residential community.
        </p>
        <div className="ga-brochure-btn-div">
          <DownloadBrochure brochureUrl={GowriAnandhamBrochure} />
        </div>
      </div>
    </div>
  );
};
